import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown, Form } from 'semantic-ui-react';

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

// FIN-1267: one warehouse of those the lists' quotations name, or none — then the tender takes them all.
const TenderWarehouseField = ({ warehouses, value, onChange, loading }) => {
  const options = (warehouses || []).map((warehouse) => ({
    key: warehouse.id,
    value: warehouse.id,
    text: `${warehouse.name} — ${plural(warehouse.quotations, 'quotation')} from ${plural(warehouse.suppliers, 'supplier')}`,
  }));
  const none = !loading && options.length === 0;
  return (
    <Form.Field className="warehouse-field">
      <label htmlFor="tender-warehouse">Warehouse</label>
      <Dropdown
        id="tender-warehouse"
        selection
        clearable
        loading={loading}
        disabled={none}
        options={options}
        value={value || ''}
        placeholder={none ? 'No quotations with a warehouse yet' : 'All warehouses'}
        onChange={(e, { value: picked }) => onChange(picked || null)}
      />
    </Form.Field>
  );
};

TenderWarehouseField.propTypes = {
  warehouses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    quotations: PropTypes.number,
    suppliers: PropTypes.number,
  })),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

TenderWarehouseField.defaultProps = { warehouses: [], value: null, loading: false };

export default TenderWarehouseField;
